import React from 'react';
import './App.css';
import { Container } from './Container';
import { asyncLocalStorage } from './Helpers/LocalStorage';
import { useUser } from './Context/User';

function App() {
    const { token, login } = useUser();
    (async () => {
        if (token === null) {
            const data = await asyncLocalStorage.getItem('token');
            const dataParsed = JSON.parse(data);
            if (dataParsed) {
                login(dataParsed.token, dataParsed.name, dataParsed.role, 100);
            }
        }
    })();

    return <Container />;
}

export default App;
